/**
 * A aba "Erros de envio" de Minhas vendas.
 *
 * Não é um status do pedido: é a venda aprovada cujo e-mail de compra não chegou ao comprador,
 * e o back filtra pelo status gravado do e-mail (`email_delivery`). Vive num módulo próprio
 * porque a página registra a aba e o serviço traduz o valor em parâmetros: com a string
 * repetida nos dois lados, um renomeio quebraria o filtro em silêncio.
 */
export const EMAIL_FAILED_TAB = 'email_failed';
